import {Button} from 'antd'
// import {useFilterByLicense} from '@/biz/license.jsx'
import useHTTP from "@/hooks/useHTTP.mjs";
import runAsync from "@/script/runAsync.mjs";
import {useMapContext} from '@/components/MindMap/index.mjs'
import {useOpenModal} from '@/components/Modal/index.mjs'
import ModalImport from './ModalImport'

export default function PropertiesPaneButtonImport({type = 'BDSUMMARY', ...props}) {
    // const filterByLicense = useFilterByLicense()
    const openModal = useOpenModal()
    const http = useHTTP();
    const map = useMapContext()
    const { refreshProduct  } = map.commands;
    const [node] = map.useSelectedNodes()
    const { mapStsCode } = map.useMetaData();

    if ('RLS' == mapStsCode) {
        return null
    }

    const doQuery = () => {
      refreshProduct([map.root]);
    };

    const doSave = async() => {
      await map.commands.saveMap()
    };

    // if (! canPreviewUv(map, node)) {
    //     return null
    // }

    const handleClick = async (e) => {
        await doSave()
        const target = e.altKey ? '_self' : '_blank'
        // previewUv(map, node, target)
        const { prjId, prjNo, sVer, pkid } = node.data;
        const res = await openModal(<ModalImport type={type} prjData={{prjId, prjNo, sVer}} />)
        if(!res?.length) {
          return;
        }
        const params = {prjId, pkid, sVer, dppBizNodeType: type, dppIds: res}
        const data = await runAsync(
            async () => {
                return await http.post("/rmucs/autoIntegrateBdLogic", params)
            },
            {
                error: {content: (err) => `导入${type == 'BDSUMMARY' ? "用户场景" : "程序能力"}: ${err.message}`},
                action: `导入${type == 'BDSUMMARY' ? "用户场景" : "程序能力"}`,
                loading: {show: true},
                success: {show: true},
            }
        );
        if(data) {
          doQuery()
        }
    }

    return <Button
          onClick={handleClick}
          {...props}
      >
          通过{type == 'BDSUMMARY' ? "用户场景" : "程序能力"}生成用例描述
      </Button>
}
